import { LoaderCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

type LoadingButtonProps = React.ComponentProps<typeof Button> & {
  isLoading: boolean
}

export default function LoadingButton({
  isLoading,
  children,
  ...rest
}: LoadingButtonProps) {
  return (
    <Button {...rest}>
      {isLoading && (
        <LoaderCircle
          className="-ms-1 me-2 animate-spin"
          size={16}
          strokeWidth={2}
          aria-hidden="true"
        />
      )}
      {children}
    </Button>
  )
}
